import { render } from "./NavigatorTokenBadge.vue?vue&type=template&id=04069046&scoped=true"
import script from "./NavigatorTokenBadge.vue?vue&type=script&lang=js"
export * from "./NavigatorTokenBadge.vue?vue&type=script&lang=js"

import "./NavigatorTokenBadge.vue?vue&type=style&index=0&id=04069046&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04069046"],['__file',"resources/js/components/NavigatorTokenBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04069046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04069046', __exports__)) {
    api.reload('04069046', __exports__)
  }
  
  module.hot.accept("./NavigatorTokenBadge.vue?vue&type=template&id=04069046&scoped=true", () => {
    api.rerender('04069046', render)
  })

}


export default __exports__